import styled from '@emotion/styled'
import { Props as ImageProps } from 'app/components/Common/Image'
import { Image } from 'app/components/Common/Image'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { theme } from 'app/theme'
import { rgba } from 'emotion-rgba'
import { Link } from 'gatsby'
import React, { memo } from 'react'
import { ArrowRight } from 'react-feather'

export interface Props {
  image?: ImageProps
  title?: string
  URL: string
  weight?: number
}

export const Item = memo(function Item({ image, title, URL }: Props) {
  if (!URL) {
    return null
  }

  return (
    <Container to={URL}>
      {image ? <Image {...image} /> : null}
      <Wrapper>
        {title ? <Title>{title}</Title> : null}
        <Arrow className="icon-arrow" dial={5}>
          <ArrowRight />
        </Arrow>
      </Wrapper>
    </Container>
  )
})

const Container = styled(Link)`
  width: 50%;
  background: ${({ theme }) => theme.colors.variants.neutralLight4};
  color: ${({ theme }) => theme.colors.variants.neutralLight4};
  overflow: hidden;
  padding: 0 3.75rem 33%;
  position: relative;
  text-align: center;
  &:hover {
    .icon-arrow {
      background: ${rgba(theme.colors.variants.neutralLight4, 0.5)};
      border-color: transparent;
    }
    img {
      transform: scale(1.1);
    }
  }
  &:nth-of-type(2) {
    transform: translateY(3.75rem);
  }
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.variants.neutralDark1};
    opacity: 0.5;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    backface-visibility: hidden;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    transition: 0.25s ease-in-out;
  }

  @media (max-width: 1023px) {
    width: 100%;
    padding: 4.0625rem 8.454vw;
    &:nth-of-type(2) {
      transform: none;
    }
  }
`

const Wrapper = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 2;
  transform: translateY(-50%);

  @media (max-width: 1023px) {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
  }
`

const Title = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 1.375rem;
  font-weight: 400;
  line-height: 1.875rem;
  margin-bottom: 1.875rem;

  @media (max-width: 1023px) {
    margin-bottom: 1.5rem;
  }
`

const Arrow = styled(FlexBox)`
  width: 5.25rem;
  height: 5.25rem;
  border: 1px solid ${rgba(theme.colors.variants.neutralLight4, 0.5)};
  border-radius: 50%;
  cursor: pointer;
  margin: auto;
  transition: 0.3s ease-in-out;
  svg {
    width: auto;
    height: 2.5rem;
    stroke: ${({ theme }) => theme.colors.variants.neutralLight4};
    stroke-width: 1;
  }

  @media (max-width: 1023px) {
    width: 3.75rem;
    height: 3.75rem;
    svg {
      stroke-width: 0.7;
    }
  }
`
